import { createSlice } from '@reduxjs/toolkit'

import { NAV_MODE, NAV_VALUES } from '@Components/navigation-bar/types'

type NavigationState = {
  activeMode: NAV_MODE
  entryPoint: NAV_MODE | null
}

const initialState: NavigationState = {
  activeMode: NAV_VALUES.VIEW_MODE,
  entryPoint: null,
}

export const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setEntryPoint(state, action) {
      state.entryPoint = action.payload
      state.activeMode = action.payload
    },
    updateActiveMode(state, action) {
      state.activeMode = action.payload
    },
  },
})

export const NavigationActions = {
  ...navigationSlice.actions,
}

export const NavigationReducer = navigationSlice.reducer
